import React from 'react';
import PropTypes from 'prop-types';

import Styles from './Input.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Input({
  containerClassName,
  containerStyle,
  inputStyle,
  inputClassName,
  icon,
  ...props
}) {
  const inputClasses = [Styles.input, inputClassName];
  if (icon) inputClasses.push(Styles.hasIcon);

  return (
    <div
      style={containerStyle}
      className={[Styles.inputContainer, containerClassName].join(' ')}
    >
      {icon ? (
        <div className={Styles.icon}>
          <FontAwesomeIcon icon={icon} />
        </div>
      ) : null}
      <input {...props} style={inputStyle} className={inputClasses.join(' ')} />
    </div>
  );
}

Input.defaultProps = {
  icon: null,
  onClick: () => null,
  onKeyUp: () => null,
  containerClassName: '',
  containerStyle: {},
  inputStyle: {},
  name: '',
  placeholder: '',
  inputClassName: '',
};

Input.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  onKeyUp: PropTypes.func,
  icon: PropTypes.any,
  containerClassName: PropTypes.string,
  containerStyle: PropTypes.instanceOf(Object),
  inputStyle: PropTypes.instanceOf(Object),
  inputClassName: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
};

export default Input;
